// Angular
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Material
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

// Translate
import { TranslateModule } from '@ngx-translate/core';

// Module components
import { AuthBaseComponent } from './components/auth-base/auth-base.component';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';

// Auth
import { AuthGuard, AuthService, RoleGuard } from '.';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';

// Modules
import { SharedModule } from '../../shared';
import { AuthRoutingModule } from './auth-routing.module';

@NgModule({
	imports: [CommonModule, FormsModule, ReactiveFormsModule, MatButtonModule, MatInputModule, MatFormFieldModule, MatCheckboxModule, MatSelectModule, TranslateModule.forChild(), NgbModule, RecaptchaModule, RecaptchaFormsModule, SharedModule, AuthRoutingModule],
	providers: [],
	exports: [AuthBaseComponent],
	declarations: [AuthBaseComponent, LoginComponent, RegisterComponent, ForgotPasswordComponent, ChangePasswordComponent],
})
export class AuthModule {
	static forRoot(): ModuleWithProviders<AuthModule> {
		return {
			ngModule: AuthModule,
			providers: [AuthService, AuthGuard, RoleGuard],
		};
	}
}
